<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <div style="overflow:auto">
            <b-table
              id="terminals-activity-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{afterResize: columnsWidthChanged}"
            >
              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:head(online)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(shop_code)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(shop_name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(terminal_name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(last_connected_at)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(last_disconnected_at)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(first_ticket_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(last_ticket_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(tickets_number)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(tickets_canceled)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(shop_status)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(duration)="data">{{ $t(data.label) }}</template>

              <template v-slot:cell(online)="data">
                <span v-if="data.value" class="text-success">{{$t("ONLINE")}}</span>
                <span v-else class="text-danger">{{$t("OFFLINE")}}</span>
              </template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>
              <template v-slot:cell(shop_name)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>
              <template v-slot:cell(terminal_name)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(last_connected_at)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(last_disconnected_at)="data">
                <span v-if="data.value != 0">{{ mom_unix(data.value).format(tableDateLong) }}</span>
                <span v-else>{{$t("IN PROGRESS")}}</span>
              </template>
              <template v-slot:cell(first_ticket_time)="data">
                <span v-if="data.value != 0">{{ mom_unix(data.value).format(tableDateLong) }}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(last_ticket_time)="data">
                <span v-if="data.value != 0">{{ mom_unix(data.value).format(tableDateLong) }}</span>
                <span v-else>-</span>
              </template>
            </b-table>
          </div>
          <!--div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'terminals-activity-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div-->
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-terminal" size="custom" scrollable>
      <template slot="modal-title">
        {{$t('Terminal')}}
        <span v-if="selected.terminalName">"{{selected.terminalName}}"</span>
      </template>
      <template slot="modal-header-close">
        <span />
      </template>
      <TerminalData :selected="selected" />
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button variant="secondary" @click="cancel()">{{$t('Cancel')}}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import TerminalData from "./TerminalData";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "terminals-activity",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    TerminalData
  },
  data: function() {
    return {
      tableName: "terminals-activity",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
          postIgnore: false
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },
        {
          field: "shop_id",
          multiple: false,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: false,
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map(elem => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map(elem => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map(elem => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                elem => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter(item => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter(item => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          }
        },
        {
          field: "online",
          multiple: false,
          placeholder: "Terminal Status",
          postIgnore: false,
          options: [
            { name: "Online", value: true },
            { name: "Offline", value: false }
          ],
          selected: []
        },
        {
          field: "report_time",
          type: "date",
          opens: "right",
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documentations for details
            showWeekNumbers: true //show week numbers on each row of the calendar
          },
          selected: {
            startDate: moment()
              .utc()
              .startOf("day"),
            endDate: moment()
              .utc()
              .endOf("day")
          },
          default: {
            startDate: moment()
              .utc()
              .startOf("day"),
            endDate: moment()
              .utc()
              .endOf("day")
          },
          ranges: {
            Today: [
              moment()
                .utc()
                .startOf("day"),
              moment()
                .utc()
                .endOf("day")
            ],
            Yesterday: [
              moment()
                .utc()
                .subtract(1, "days")
                .startOf("day"),
              moment()
                .utc()
                .subtract(1, "days")
                .endOf("day")
            ],
            "This week": [
              moment()
                .utc()
                .startOf("isoWeek"),
              moment()
                .utc()
                .endOf("isoWeek")
            ],
            "Last week": [
              moment()
                .utc()
                .subtract(1, "week")
                .startOf("isoWeek"),
              moment()
                .utc()
                .subtract(1, "week")
                .endOf("isoWeek")
            ],
            "This month": [
              moment()
                .utc()
                .startOf("month"),
              moment()
                .utc()
                .endOf("month")
            ],
            "Last month": [
              moment()
                .utc()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .utc()
                .subtract(1, "month")
                .endOf("month")
            ],
            "This year": [
              moment()
                .utc()
                .startOf("year"),
              moment()
                .utc()
                .endOf("year")
            ],
            "Last year": [
              moment()
                .utc()
                .subtract(1, "year"),
              moment().utc()
            ]
          }
        }
      ],
      isBusy: false,
      sortBy: "report_time",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        {
          key: "online",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "shop_code",
          label: "Code",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "terminal_name",
          label: "Terminal",
          sortable: false,
          class: "",
          ignore: true
        },
        { key: "last_connected_at", sortable: false, class: "", ignore: true },
        {
          key: "last_disconnected_at",
          sortable: false,
          class: "",
          ignore: true
        },
        { key: "duration", sortable: false, class: "", ignore: true },
        {
          key: "first_ticket_time",
          label: "Date when first ticket was created",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "last_ticket_time",
          label: "Date when last ticket was created",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "tickets_number",
          label: "# cashed in ticket",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "tickets_canceled",
          label: "# storned in ticket",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "shop_status",
          label: "Status",
          sortable: false,
          class: "",
          ignore: true
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
      selected: {
        terminalID: null,
        terminalName: null,
        startTime: null,
        endTime: null
      }
    };
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "terminals-activity-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        if (sortBy == "eterminal_id") sortBy = "terminal_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          if (item.field === "terminal_id") {
            exactFields.push(
              item.selected[0] === "1" ? "!" + item.field : item.field
            );
            exactValues.push(["LOIQ6p7TaKDBIpfb-Pvm_A"]);
          } else {
            exactFields.push(item.field);
            if (item.trackBy) {
              const tmp = [];
              item.selected.forEach(el => {
                tmp.push(el[item.trackBy]);
              });
              exactValues.push(tmp);
            } else {
              exactValues.push(item.selected);
            }
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      this.$store
        .dispatch("terminalActivity/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.length;
          resp.data.forEach((item, index) => {
            if (item.shop_code) {
              if (item.shop_id) {
                item.shop_code = {
                  to: item.shop_id,
                  name: item.shop_code
                };
              } else {
                item.shop_code = {
                  to: null,
                  name: item.shop_code
                };
              }
            }

            if (item.shop_name) {
              if (item.shop_id) {
                item.shop_name = {
                  to: item.shop_id,
                  name: item.shop_name
                };
              } else {
                item.shop_name = {
                  to: null,
                  name: item.shop_name
                };
              }
            }

            if (item.terminal_name) {
              if (item.shop_id) {
                item.terminal_name = {
                  to: item.shop_id,
                  name: item.terminal_name
                };
              } else {
                item.terminal_name = {
                  to: null,
                  name: item.terminal_name
                };
              }
            }

            item.duration = this.duration(
              item.last_connected_at,
              item.last_disconnected_at
            );
          });
          callback(resp.data);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      const selected = {
        terminalID: item.terminal_id,
        terminalName: item.terminal_name.name,
        startTime: null,
        endTime: null
      };

      this.filterOptions.forEach(item => {
        if (item.type == "date") {
          selected.startTime = item.selected.startDate;
          selected.endTime = item.selected.endDate;
        }
      });

      this.selected = selected;

      this.$bvModal.show("bv-modal-terminal");
    },
    mom_unix(val) {
      return moment.unix(val / 1e9);
    },
    duration(sd, ed) {
      sd = this.mom_unix(sd);
      if (ed === 0) {
        ed = moment();
      } else {
        ed = this.mom_unix(ed);
      }
      const dr = moment.duration(ed.diff(sd));
      let ret = "";
      if (dr.days()) {
        ret = `${dr.days()}d `;
      }
      if (dr.hours()) {
        ret = ret + `${dr.hours()}h `;
      }
      if (dr.minutes()) {
        ret = ret + `${dr.minutes()} min `;
      }
      if (dr.seconds()) {
        ret = ret + `${dr.seconds()} sec `;
      }
      return ret;
    },
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
</style>


